export const SkillsData = [
  {
    type: "Front-End",
    list: [
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>,
      },
      {
        name: "Angular",
        icon: <i class="devicon-angularjs-plain colored"></i>,
      },
      {
        name: "HTML5",
        icon: <i class="devicon-html5-plain colored"></i>,
      },
      {
        name: "CSS3",
        icon: <i class="devicon-css3-plain colored"></i>,
      },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>,
      },
    ],
  },
  {
    type: "Back-End",
    list: [
      {
        name: "Java/Spring Boot",
        icon: <i class="devicon-java-plain colored"></i>,
      },
      {
        name: "PHP/Laravel",
        icon: <i class="devicon-laravel-plain colored"></i>,
      },
    ],
  },
  {
    type: "Other Skills",
    list: [
      {
        name: "Bootstrap",
        icon: <i class="devicon-bootstrap-plain colored"></i>,
      },
      {
        name: "Photoshop",
        icon: <i class="devicon-photoshop-plain colored"></i>,
      },
      {
        name: "Illustrator",
        icon: <i class="devicon-illustrator-plain colored"></i>,
      },
    ],
  },
];
